var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEDisease(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x35__x2C__Solidarity_x2C__health_x2C__disease",
    transform: "translate(-49.338 -49.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15885_",
    transform: "translate(49.338 49.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15886_",
    d: "M337.2,336.144c-.4-.038-.811-.078-1.2-.143.063.372.1.77.143,1.157a4.582,4.582,0,0,0,.684,2.516,2.023,2.023,0,1,0,2.861-2.861A4.455,4.455,0,0,0,337.2,336.144Z",
    transform: "translate(-320.049 -320.049)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15887_",
    d: "M99.953,336.827a2.023,2.023,0,0,0,2.861,2.861,4.455,4.455,0,0,0,.67-2.491c.038-.4.078-.811.143-1.2-.372.063-.77.1-1.157.143A4.582,4.582,0,0,0,99.953,336.827Z",
    transform: "translate(-96.579 -320.048)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15888_",
    d: "M102.181,103.466c.4.038.811.078,1.2.143-.063-.372-.1-.77-.143-1.157a4.582,4.582,0,0,0-.684-2.516,2.023,2.023,0,0,0-2.861,2.861A4.455,4.455,0,0,0,102.181,103.466Z",
    transform: "translate(-96.33 -96.56)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15889_",
    d: "M339.676,102.55a2.023,2.023,0,0,0-2.861-2.861,4.455,4.455,0,0,0-.67,2.49c-.038.4-.078.811-.142,1.2.372-.063.77-.1,1.157-.143A4.582,4.582,0,0,0,339.676,102.55Z",
    transform: "translate(-320.05 -96.328)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15890_",
    d: "M221.507,54.545c.219-.308.472-.618.718-.921a4.582,4.582,0,0,0,1.294-2.261,2.022,2.022,0,1,0-4.045,0A4.444,4.444,0,0,0,220.76,53.6C221.016,53.907,221.279,54.225,221.507,54.545Z",
    transform: "translate(-210.006 -49.339)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15891_",
    d: "M54.544,221.853c-.308-.219-.618-.472-.921-.718a4.582,4.582,0,0,0-2.261-1.294,2.022,2.022,0,1,0,0,4.045A4.444,4.444,0,0,0,53.6,222.6C53.906,222.344,54.224,222.081,54.544,221.853Z",
    transform: "translate(-49.338 -210.353)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15892_",
    d: "M221.853,369.111c-.219.308-.472.618-.718.921a4.582,4.582,0,0,0-1.294,2.261,2.022,2.022,0,1,0,4.045,0,4.444,4.444,0,0,0-1.286-2.234C222.344,369.749,222.081,369.43,221.853,369.111Z",
    transform: "translate(-210.353 -351.317)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15893_",
    d: "M372.293,219.473a4.444,4.444,0,0,0-2.234,1.286c-.31.256-.629.519-.948.747.308.219.618.472.921.718a4.582,4.582,0,0,0,2.261,1.294,2.022,2.022,0,1,0,0-4.045Z",
    transform: "translate(-351.317 -210.006)",
    fill: "#117446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15894_",
    d: "M171.414,168.112l1.3-.608-1.3-.608a1.376,1.376,0,0,1-.715-1.729l.493-1.351-1.351.493a1.383,1.383,0,0,1-1.729-.715l-.608-1.3-.608,1.3a1.389,1.389,0,0,1-1.254.8h0a1.378,1.378,0,0,1-.474-.084l-1.351-.493.493,1.351a1.376,1.376,0,0,1-.715,1.729l-1.3.608,1.3.608a1.376,1.376,0,0,1,.715,1.729l-.493,1.351,1.351-.493a1.383,1.383,0,0,1,1.729.715l.608,1.3.608-1.3a1.383,1.383,0,0,1,1.729-.715l1.351.493-.493-1.351A1.376,1.376,0,0,1,171.414,168.112Z",
    transform: "translate(-156.004 -156.004)",
    fill: "#117446"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEDisease);
export default __webpack_public_path__ + "static/media/eDisease.e641c417ba3f20494bc0890d882e4511.svg";
export { ForwardRef as ReactComponent };